module.exports = __webpack_public_path__ + "static/3dprinter-c8f3e942651756c9aa0df609f7a4c9cb.jpg";